module.exports = __webpack_public_path__ + "static/media/am_logo.cbe6a74e.svg";